export default __webpack_public_path__ + "static/img_0-446502b1115f6df0d12fa02f80e7682b.jpg";